export const GRAPH_API_PROFILE = process.env.REACT_APP_GRAPH_API_PROFILE
export const GRAPH_API_PREDICTION = process.env.REACT_APP_GRAPH_API_PREDICTION
export const GRAPH_API_LOTTERY = process.env.REACT_APP_GRAPH_API_LOTTERY
export const SNAPSHOT_VOTING_API = process.env.REACT_APP_SNAPSHOT_VOTING_API
export const SNAPSHOT_BASE_URL = process.env.REACT_APP_SNAPSHOT_BASE_URL
export const API_PROFILE = process.env.REACT_APP_API_PROFILE
export const API_NFT = process.env.REACT_APP_API_NFT
export const SNAPSHOT_API = `${SNAPSHOT_BASE_URL}/graphql`
export const SNAPSHOT_HUB_API = `${SNAPSHOT_BASE_URL}/api/message`

/**
 * V1 will be deprecated but is still used to claim old rounds
 */
export const GRAPH_API_PREDICTION_V1 = 'https://api.thegraph.com/subgraphs/name/pancakeswap/prediction'

export const INFO_CLIENT = 'https://api.thegraph.com/subgraphs/name/top1st/harvest-info'
export const INFO_CLIENT_API = 'https://proxy-worker.pancake-swap.workers.dev'
export const BLOCKS_CLIENT = 'https://api.thegraph.com/subgraphs/name/pancakeswap/blocks'

export const PRICE_GRAPH_API = 'https://app.yad.finance'
export const PROXY_API = 'https://graph.ncx.cx'
// export const PROXY_API = 'http://localhost:5010'

export const getPriceGraphApiUrl = (chainId?: number | string, token0?: string, token1?: string, timeWindow?: string) =>
  !!token0 && !!token1 && !!chainId ? `/api/graph/${Number(chainId)}/${token0}/${Number(chainId)}/${token1}/${timeWindow}/CLASSIC_MODE` : ``
export const getPriceUSDApiUrl = (chainId?: number | string): string =>
  `/api/rates/${chainId}?_data=routes/api/rates.$chainId`
export const getInfoClientApiUrl = () => `/bsc-exchange`

export const fetchData = async (targetApiRoot, urlRoute, method, reqBody, origin) =>
  fetch(`${PROXY_API}${urlRoute}`, {
    method,
    body: reqBody,
    headers: { 'content-type': 'application/json', 'Target-URL': `${targetApiRoot}`, 'x-provider': origin },
  })

export const GRAPH_API_NFTMARKET = process.env.REACT_APP_GRAPH_API_NFT_MARKET
